import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            as: 'section',
            width: '100%',
            spacing: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
        },
        header: {
            alignItems: 'flex-start',
            gap: 'xxsmall.base',
        },
        headerIcon: {
            boxSize: remCalc(20),
            color: 'foreground.neutral.default',
            h: remCalc(20),
        },
        headerTextBlock: {
            gap: 'micro.base',
        },
        title: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        subtitle: {
            textStyle: 'body-medium',
            color: 'foreground.neutral.subtle',
            fontWeight: 'normal',
            noOfLines: 2,
        },
        list: {
            as: 'ul',
            spacing: 'xxsmall-1.base',
            listStyleType: 'none',
            m: 0,
            p: 0,
        },
        card: {
            as: 'li',
            listStyleType: 'none',
            border: 'small',
            borderColor: 'border.table',
            bg: 'background.base.under',
            borderRadius: 'large-1',
            padding: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
        },
        cardRow: {
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
        },
        cardContent: {
            flex: 1,
            spacing: ['micro.base', 'micro.md', 'micro.lg', 'micro.xl'],
            minW: 0,
        },
        cardTitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        cardDescription: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
            noOfLines: 2,
        },
        learnMore: {
            textDecoration: 'underline',
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        learnMoreBadge: {
            display: 'inline-flex',
            alignItems: 'center',
            px: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            py: 0,
            borderRadius: 'small',
            border: 'small',
            borderColor: 'border.neutral.default',
            bg: 'background.base.elevated',
            color: 'foreground.neutral.default',
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            lineHeight: remCalc(16),
        },
        checkboxWrapper: {
            minW: remCalc(16),
            maxW: remCalc(16),
            h: remCalc(16),
            pt: remCalc(3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '.chakra-checkbox__control': {
                borderRadius: 'medium',
                border: 'small',
                borderColor: 'border.neutral.highlight',
            },
        },
        warrantyDropdown: {
            pt: 'xsmall.base',
        },
        planSelect: {
            borderColor: 'border.neutral.highlight',
            borderRadius: 'medium',
            bg: 'background.base.elevated',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        planOption: {
            color: 'foreground.neutral.default',
            backgroundColor: 'background.base.elevated',
        },
        planOptionRow: {
            width: '100%',
            alignItems: 'center',
            minWidth: 0,
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        planOptionTitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            minWidth: 0,
        },
        planOptionPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
            whiteSpace: 'nowrap',
        },
        planPriceStack: {
            pt: 'xxsmall.base',
            gap: 'micro.base',
        },
        planPriceRow: {
            gap: remCalc(8),
            alignItems: 'baseline',
        },
        planCurrentPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        planListPrice: {
            textStyle: 'body-small',
        },
        planDiscount: {
            textStyle: 'body-small',
        },
        planPerYear: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
        },
    },
}
